module.exports = __webpack_public_path__ + "img/4.11740a45.png";